import React from "react";
import "./DaySchedule.css";
import DeleteRdvButton from "./DeleteRdvButton/DeleteRdvButton";

// Fonction pour générer une couleur TRÈS pastel basée sur une chaîne
const generatePastelColor = (str) => {
  if (!str) return 'rgba(200, 200, 200, 0.8)'; // Gris plus sombre et moins transparent
  
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const r = ((hash & 0xFF0000) >> 16) % 35 + 210;
  const g = ((hash & 0x00FF00) >> 8) % 35 + 210;
  const b = (hash & 0x0000FF) % 35 + 210;
  
  return `rgba(${r}, ${g}, ${b}, 0.4)`;
};

// Fonction pour obtenir la couleur selon le statut de la mission
const getMissionColor = (mission) => {
  if (!mission) return undefined;
  
  // Si la mission est terminée, afficher en vert peu importe le nom
  if (mission.status === 'completed') {
    return 'rgba(76, 175, 80, 0.6)'; // Vert pour les missions terminées
  }
  
  // Sinon, utiliser la couleur basée sur le nom de l'opération
  return generatePastelColor(mission.operation_name);
};

const DaySchedule = ({
  daySlots,
  dayIndex,
  rdvs,
  handleMouseDown,
  handleMouseUp,
  handleMouseEnter,
  deleteRdv,
  startIndex,
  endIndex,
  draggingDayIndex,
  openMissionPopup,
}) => {
  return (
    <div className="day">
      <div className="time-slots">
        {daySlots.map((time, index) => {
          const currentRdv = rdvs[dayIndex].find(
            (rdv) => index >= rdv.beginning && index <= rdv.ending - 1
          );
          const isOccupied = !!currentRdv;
          const isRdvStart = currentRdv && index === currentRdv.beginning;
          const isRdvEnd = currentRdv && index === currentRdv.ending - 1;

          // Utiliser la nouvelle fonction pour obtenir la couleur
          const backgroundColor = isOccupied 
            ? getMissionColor(currentRdv)
            : undefined;


          return (
            <div
              key={index}
              className={`time-slot 
                ${isOccupied ? "occupied" : ""} 
                ${isRdvStart ? "rdv-start" : ""}
                ${isRdvEnd ? "rdv-end" : ""}
                ${
                  ((startIndex <= index && endIndex >= index) ||
                    (startIndex >= index && endIndex <= index)) &&
                  startIndex !== null &&
                  endIndex !== null &&
                  draggingDayIndex === dayIndex
                    ? "hovered"
                    : ""
                } 
                ${index % 4 === 0 ? "hour-separator" : ""} 
                ${index === 35 ? "last-hour-separator" : ""}`}
              style={backgroundColor ? { backgroundColor } : {}}
              onMouseDown={() => handleMouseDown(time.time, index, dayIndex)}
              onMouseUp={() => handleMouseUp(time.time, dayIndex)}
              onMouseEnter={() => handleMouseEnter(time.time, index)}
              onDoubleClick={() => openMissionPopup(time.associatedRdv)}
            >
              {isRdvStart && (
                <>
                  <div className="rdv-info">
                    <span className="client-name">{currentRdv.client_name}</span>
                  </div>
                  <DeleteRdvButton
                    rdvIndex={index}
                    dayIndex={dayIndex}
                    deleteRdv={deleteRdv}
                  />
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DaySchedule;
